<template>
    <Footer1 v-if="shopTheme === 'type_1'" v-bind:data="getFooterSettings" />
    <Footer2 v-else-if="shopTheme === 'type_2'" v-bind:data="getFooterSettings" />
    <Footer3 v-else-if="shopTheme === 'type_3'" v-bind:data="getFooterSettings" />
    <Footer4 v-else-if="shopTheme === 'type_4'" v-bind:data="getFooterSettings" />
    <Footer5 v-else-if="shopTheme === 'type_5'" v-bind:data="getFooterSettings" />
    <Footer6 v-else-if="shopTheme === 'type_6'" v-bind:data="getFooterSettings" />
    <Footer7 v-else-if="shopTheme === 'type_7'" v-bind:data="getFooterSettings" />
    <Footer3 v-else v-bind:data="getFooterSettings" />
</template>

<script>
    import Footer1 from './type_1/Footer.vue';
    import Footer2 from './type_2/Footer.vue';
    import Footer3 from './type_3/Footer.vue';
    import Footer4 from './type_4/Footer.vue';
    import Footer5 from './type_5/Footer.vue';
    import Footer6 from './type_6/Footer.vue';
    import Footer7 from './type_7/Footer.vue';
    import { mapGetters, mapMutations } from 'vuex';

    export default {
        name: 'Footers',
        components: {
            Footer1,
            Footer2,
            Footer3,
            Footer4,
            Footer5,
            Footer6,
            Footer7,
        },
        mounted() {
            this.__getFooterSettings();
        },
        data: () => ({}),
        computed: {
            ...mapGetters('auth', ['shopTheme']),
            ...mapGetters('app', [
                'getHeaderSettings',
                'getFooterSettings',
            ]),
        },
        methods: {
            ...mapMutations('app', [
                'setHeaderSettings',
                'setFooterSettings',
            ]),
            async __getFooterSettings() {
                const res = await this.call_api('get', `setting/footer`);
                if (res.status === 200) {
                    this.setFooterSettings(res.data);
                }
            },
        },
    };
</script>
